import IconDonut from 'components/icons/donut-with-bite';
import IconHeartSimple from 'components/icons/heart-simple';
import IconTimsBag from 'components/icons/tims-bag';
import IconTimsCup from 'components/icons/tims-cup';

export const DEFAULT_ICON = IconTimsBag;

export const NEARBY_ERROR_ICON = IconDonut;
export const NEARBY_NO_STORES_ICON = IconTimsBag;
export const NEARBY_NO_LOCATION_ICON = IconTimsBag;

export const FAVORITES_ERROR_ICON = IconDonut;
export const FAVORITES_NO_AUTH_ICON = IconHeartSimple;
export const FAVORITES_NO_STORES_ICON = IconHeartSimple;

export const RECENT_ERROR_ICON = IconDonut;
export const RECENT_NO_AUTH_ICON = IconTimsCup;
export const RECENT_NO_STORES_ICON = IconDonut;
